module.exports = __webpack_public_path__ + "images/2aecb8f98b47e9b8cd591b6dd115401e.png";